import { render, staticRenderFns } from "./ClientConfigPage.vue?vue&type=template&id=cd2ccd54"
import script from "./ClientConfigPage.vue?vue&type=script&lang=js"
export * from "./ClientConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd2ccd54')) {
      api.createRecord('cd2ccd54', component.options)
    } else {
      api.reload('cd2ccd54', component.options)
    }
    module.hot.accept("./ClientConfigPage.vue?vue&type=template&id=cd2ccd54", function () {
      api.rerender('cd2ccd54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientConfigPage.vue"
export default component.exports